import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressPromoteSeoRobotsServerV2AdsServiceV2Url(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www._base_domain_': [
      {
        srcPath: '/_api/promote-seo-robots-server',
        destPath: '/api',
      },
      {
        srcPath: '/_api/promote-seo-robots-server/v2/robots',
        destPath: '/v2/robots',
      },
      {
        srcPath: '/_api/promote-seo-robots-server/v2/ads',
        destPath: '/v2/ads',
      },
      {
        srcPath: '/_api/promote-seo-robots-server/v2/llms',
        destPath: '/v2/llms',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/promote-seo-robots-server',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/promote-seo-robots-server',
        destPath: '/api',
      },
      {
        srcPath: '/_api/promote-seo-robots-server/v2/robots',
        destPath: '/v2/robots',
      },
      {
        srcPath: '/_api/promote-seo-robots-server/v2/ads',
        destPath: '/v2/ads',
      },
      {
        srcPath: '/_api/promote-seo-robots-server/v2/llms',
        destPath: '/v2/llms',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/promote-seo-robots-server/v2/robots',
        destPath: '/v2/robots',
      },
      {
        srcPath: '/promote-seo-robots-server/v2/ads',
        destPath: '/v2/ads',
      },
      {
        srcPath: '/promote-seo-txt-file-server/v2/ads',
        destPath: '/v2/ads',
      },
      {
        srcPath: '/promote-seo-txt-file-server/v2/robots',
        destPath: '/v2/robots',
      },
      {
        srcPath: '/promote-seo-robots-server/v2/llms',
        destPath: '/v2/llms',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/promote/marketing/v2/ads',
        destPath: '/v2/ads',
      },
      {
        srcPath: '/promote/seo/v2/llms',
        destPath: '/v2/llms',
      },
      {
        srcPath: '/promote/seo/v2/robots',
        destPath: '/v2/robots',
      },
    ],
    _: [
      {
        srcPath: '/promote/marketing/v2/ads',
        destPath: '/v2/ads',
      },
      {
        srcPath: '/promote/seo/v2/llms',
        destPath: '/v2/llms',
      },
      {
        srcPath: '/promote/seo/v2/robots',
        destPath: '/v2/robots',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_marketing_ads-txt';

/** Retrieves the Ads.txt file. */
export function getAdsTxt(payload: object): RequestOptionsFactory<any> {
  function __getAdsTxt({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.promote.marketing.v2.ads_txt',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.promote.seo.robots.server.v2.AdsServiceV2.GetAdsTxt',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPromoteSeoRobotsServerV2AdsServiceV2Url({
        protoPath: '/v2/ads',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getAdsTxt;
}

/**
 * Updates the Ads.txt file.
 * When setting the `content` object to an empty string, an empty Ads.txt file will be created.
 * In order to reset Ads.txt to Wix's default, send `default: true` without a `content` object.
 */
export function updateAdsTxt(payload: object): RequestOptionsFactory<any> {
  function __updateAdsTxt({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.promote.marketing.v2.ads_txt',
      method: 'PUT' as any,
      methodFqn:
        'com.wixpress.promote.seo.robots.server.v2.AdsServiceV2.UpdateAdsTxt',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPromoteSeoRobotsServerV2AdsServiceV2Url({
        protoPath: '/v2/ads',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __updateAdsTxt;
}

/**
 * Appends the submitted `content` object to Ads.txt.
 * In order to reset Ads.txt to Wix's default, send `default: true` without a `content` object.
 */
export function appendAdsTxt(payload: object): RequestOptionsFactory<any> {
  function __appendAdsTxt({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.promote.marketing.v2.ads_txt',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.promote.seo.robots.server.v2.AdsServiceV2.AppendAdsTxt',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPromoteSeoRobotsServerV2AdsServiceV2Url({
        protoPath: '/v2/ads',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __appendAdsTxt;
}
